import { Title } from '@components/atoms/Title';
import { Button, Footer } from '@components/atoms';
import { useUserContext } from '@context/UserContext';
import { useNavigate } from 'react-router-dom';
import { SuccessCard } from '@components/organism';
import { UserData } from '@constants/useUserData';

export function UserSuccessAccount() {
    const { selectedUser: user, newUserFormData, setSelectedUser, setNewUserFormData } = useUserContext();
    const { getDocumentInfo } = UserData(user);
    const navigate = useNavigate();

    const displayUser = {
        id: user,
        name:  `${user?.user_fields?.cnpj_regex ? user?.user_fields?._pessoa_juridica__razao_social : user?.name}`,
        user_fields: { cpf_3: newUserFormData.cpf_3 },
        phone: newUserFormData.phone,
        email: newUserFormData.email
    };

    if (!displayUser) return <div className="p-4">Usuário não encontrado.</div>;
    const info = [
        {
            label: `${user?.user_fields?.cnpj_regex ? 'Razão Social' : 'Nome'}`,
            value: displayUser.name,
        },
        getDocumentInfo(),
        { label: 'Número', value: displayUser.id?.phone ?? '—' },
        { label: 'E-mail', value: displayUser.id?.email ?? '—' },
    ];

    const handleBack = () => {
        setSelectedUser(null);
        setNewUserFormData({ name: '', cpf_3: '', phone: '', email: '', cnpj_regex: '', tipoConta: '' });
        navigate('/');
    };

    return (
        <div className="bg-[#e8f5ee] h-160 flex flex-col">
            <div className="p-4">
                <Title title={newUserFormData?.name ? "• Usuário criado" : "• Conta adicionada"} />
            </div>

            <SuccessCard
                title={newUserFormData?.name ? 'Usuário criado com sucesso!' : 'Conta criada com sucesso!'}
                info={info}
            />

            <Footer>
                <Button isStretched onClick={handleBack}>
                    Voltar
                </Button>
            </Footer>
        </div>
    );
}